<template>
  <v-container fluid>
    <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Projeto
        <v-progress-circular
          v-if="!loaded"
          indeterminate
          color="secondary"
        ></v-progress-circular>
      </div>
      <v-spacer></v-spacer>
      <v-btn v-show="projectId" class="primary" @click="createCopy"> Criar cópia</v-btn>
    </v-row>
    <contact-card :disabled="true||(projectId !==undefined)||(project.id!==undefined)" v-if="loaded" :contact="project.contact"></contact-card>
    <site-card
      :disabled="(projectId !==undefined)||(project.id!==undefined) "
      v-show="loaded"
      @calcQuote="calc"
      :calculating="calculating"
      :loadedCity="loadedCity"
      :site="project.site"
      :structureOptions="structureOptions"
      :structures="structures"
      :modules="modules"
      :generators="generators"
      :quoteProfilesOptions="quoteProfilesOptions"
      :inverterManufacturers="inverterManufacturers"
      :generatorManufacturers="generatorManufacturers"
    ></site-card>

    <solar-plant-card
    :disabled="(projectId !==undefined)||(project.id!==undefined) "
      v-show="project.solarPlant.dcPower"
      :dcPower="project.solarPlant.dcPower"
      :solarPlant="project.solarPlant"
      :site="project.site"
      :quote = "project.quote"
      :accessEfficiency = "accessEfficiency"
    ></solar-plant-card>

 <assembly-card 
              v-if= "((project.profile)&&(project.profile.customMounting))    &&(project.solarPlant)&&(project.solarPlant.mountings)&&(project.solarPlant.mountings.length>0)"
              @recalc="recalc"
              :disabled="((projectId !==undefined)||(project.id!==undefined))"
                v-show="true"
                :mountings="project.solarPlant.mountings"
                :solarPlant="project.solarPlant"
                :structures="structures"
        
              
              ></assembly-card>

    <quote-card
    :disabled="(projectId !==undefined)||(project.id!==undefined) "
      v-if="project.quote.products.items.length > 0"
      :quote="project.quote"
      :solarPlant="project.solarPlant"
      :site="project.site"
      :enterprise="enterprise"
      :accessDiscount= "accessDiscount"
      :accessUnitPrice = "accessUnitPrice"
    >
      ></quote-card
    >

    <v-container style="max-width: 1800px">
      <v-card class="ma-4">
        <v-row>
          <v-btn
            v-show="project.solarPlant.dcPower"
            class="ma-4 primary"
            @click="saveProject"

            :disabled= "(projectId !==undefined) || saving"
          >
            <span v-show="!saving"
              ><v-icon>mdi-content-save</v-icon> Salvar</span
            >
            <v-progress-circular
              v-show="saving"
              indeterminate
              color="white"
            ></v-progress-circular>
          </v-btn>

          <v-spacer></v-spacer>
         

           <v-btn v-if="project.createdAt"
            v-show="project.solarPlant.dcPower"
            class="ma-4 primary"
            @click="downloadPdf"
          >
            <span v-show="!creatingPdf"
              ><v-icon>mdi-download</v-icon> Download</span
            >
            <v-progress-circular
              v-show="creatingPdf"
              indeterminate
              color="white"
            ></v-progress-circular>
          </v-btn>
        </v-row>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
//import { ContactCard, SiteCard ,SolarPlantCard ,QuoteCard} from "@/components";
import Inverter from "@/libraries/classes/devices/Inverter.js";
import Module from "@/libraries/classes/devices/Module.js";
import SolarFunctions from "../../../../libraries/classes/SolarFunctions";
import SolarPlant from "../../../../libraries/classes/SolarPlant";
import Quote from "../../../../libraries/classes/Quote";


import finance from "@/libraries/functions/finance.js";
import cityNames from "@/libraries/data/cityNames.js";
import _ from "lodash";
import pdfDoc from "@/libraries/jspdf/jspdf.js";

import ContactCard from "../../components/cards/ContactCard.vue";
import SiteCard from "../../components/cards/SiteCard.vue";
import SolarPlantCard from "../../components/cards/SolarPlantCard.vue";
import QuoteCard from "../../components/cards/QuoteCard.vue";
import Generator from "../../../../libraries/classes/devices/Generator";
import DaoVue from "../../../../libraries/classes/DaoVue"
import hebelApi from '../../../../libraries/hebel/hebelApi';
import AssemblyCard from '../../components/cards/AssemblyCard'

export default {
  name: "Project",
  props: ["projectId","dealId"],
  components: {
    ContactCard,
    SiteCard,
    SolarPlantCard,
    QuoteCard,
    AssemblyCard
    // SiteCard,
    // SolarPlantCard,
    // QuoteCard
  },
  data() {
    return {
      user:{},
      deal:{},
      formula: "",
      loaded: false,
      calculating: false,
      loadedCity: false,
      enterprise: {},
      fields: [],
      creatingPdf: false,
      saving: false,
      project: {
        createdAt: 0,
        owner:{},
        contact: { name: "", email: "",phone:""},
        profile:{},//Perfil de orçamento
        site: {
          cityName: "Campinas - SP",
          city: {},
          streetAddress: "",
          streetAddressNumber: "",
          streetAddressLine2: "", //complemento
          zipCode: "",
          neighborhood: "", //Bairro

          electricalProps: {
            averageBilling: {
              unit: "kWh",
              price: 0.7,
              quantity: 662.74,
              total: 463.92,
              type: "B2",
              factor: 1,
              description: "Energia ativa",
              minAmount: 100,
            },
            voltage: 220,
            phases: 3,
          },
          solarRequest: {
            complete: true, //solarPlant installed or not
            quoteProfileId: 0, //number
            manufacturer: "HOPESUN", //Load from client
            moduleId: "4CasSYnur1DU8hp3Sjca",
            structureId: "u9e0ms8LTZuKgWzSMVrs",
            module: {},
            dcPower: 5, // From calculation
            consumption: 662.74,
            production: 500,
            calcType: "kWh",
            customKit: false, //true = kit aberto, false, kit fechado.
            estimated: true, //true == create new generator based on the generators, false - just search available kits
            efficiency: 77,
            components: {
              stringbox: true,
              transformer: true,
            },
          },
        },
        solarPlant: {},
        quote: {
          products: {
            items: [],
          },
          cost: 0,
          price: 0,
          cashFlow: [],
          formCashShow: {
            investmentCost: 100000.0,
            upFrontInvesment: 10000.0,
            numberOfPayments: 1,
            loanInterestRate: 10.0,
            inflationRate: 10.0,
            monthlySavings: 500.0,
          },
        },
      },
      structures: [],
      stringboxes: [],
      cables: [],
      connectors: [],
      transformers: [],
      structureOptions: [],
      modules: [],
      moduleSel: 0,
      moduleOptions: [],
      list: [],
      cityName: "",
      phases: 3,
      manufacturer: "INVT",
      quoteProfilesOptions: [],
      kWpFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "kWp",
        precision: 2,
        masked: false,
      },
      // test: [],
      cashFlow: [],
      formCashShow: {
        investmentCost: 100000.0,
        upFrontInvesment: 10000.0,
        numberOfPayments: 1,
        loanInterestRate: 10.0,
        inflationRate: 10.0,
        monthlySavings: 500.0,
      },
      i: {},
      module: {},
      inverter: {},
      inverters: [],

      inverterManufacturers: [],
      generators: [],
      generatorManufacturers: [],
      filterInverters: [],
      generatorsFilter: [],
      solarPlants: [],
      accessDiscount:true,
      accessUnitPrice:true,
      accessEfficiency:true,

    };
  },

  async created() {
      this.user = this.$session.get('user');
      if(this.user.profile){
        this.accessDiscount = this.user.profile.access.discount;
        this.accessUnitPrice = this.user.profile.access.unitPrice;
        this.accessEfficiency = this.user.profile.access.efficiency;
     }


      if(this.dealId){
        this.deal = await hebelApi.deals.getFromId(this.dealId);
      if(this.deal.contactId ){
          this.deal.contact = await hebelApi.contacts.getFromId(this.deal.contactId);  
          //alert(JSON.stringify( this.deal.contact ));
      }
      this.project.contact = this.deal.contact;   
    }
    //DaoVue.getEnterprise();
    //this.fields = await this.$dao.getFields(window.eid);
    this.fields = await hebelApi.fields.getAll();

    //this.enterprise = await this.$dao.getEnterprise(window.eid);
    this.enterprise = await hebelApi.enterprises.getFromId(window.eid);
    
    if (this.enterprise.quoteProfiles[0].customKit)
      this.project.site.solarRequest.customKit = this.enterprise.quoteProfiles[0].customKit;

    this.quoteProfilesOptions = [];
    for (var q = 0; q < this.enterprise.quoteProfiles.length; q++) {
      this.quoteProfilesOptions.push({
        text: this.enterprise.quoteProfiles[q].description,
        value: q,
      });
    }

    //this.modules = await this.$dao.getAllModules(window.eid)
    this.modules = await hebelApi.devices.getAllModules();

    this.project.site.solarRequest.moduleId = this.modules[0].id;
    this.project.site.cityName = this.enterprise.cityName;

    for (var a = 0; a < this.modules.length; a++) {
      this.moduleOptions.push({
        value: this.modules[a].id,
        text: `(${this.modules[a].manufacturer}) ${this.modules[a].code} `,
      });
    }


    var x = this.modules.find(
      (element) => element.id == this.project.site.solarRequest.moduleId
    );

    var m = new Module();
    m = Object.assign(m,x);

    this.project.site.solarRequest.module = m;

    //this.project.site.city = await this.$dao.getCity( this.project.site.cityName );
    this.project.site.city = await hebelApi.cities.get(this.project.site.cityName)
   


    //this.inverters = await this.$dao.getDevices(  window.eid,  "*",   "inverter",   true  );
    this.inverters = await hebelApi.devices.getAll( "*",   "inverter",   true );
    //this.generators = await this.$dao.getDevices(  window.eid,   "*",   "generator",   true   );
    this.generators = await hebelApi.devices.getAll("*",   "generator",   true  )




    this.inverterManufacturers = [
      ...new Set(this.inverters.map((obj) => obj.manufacturer)),
    ];
    this.generatorManufacturers = [
      ...new Set(this.generators.map((obj) => obj.manufacturer)),
    ];


    //alert(JSON.stringify(manufacturers));
    if (this.project.site.solarRequest.customKit) {
      if (this.inverterManufacturers.length > 0)
        this.project.site.solarRequest.manufacturer = this.inverterManufacturers[0];
    } else {
      if (this.generatorManufacturers.length > 0)
        this.project.site.solarRequest.manufacturer = this.generatorManufacturers[0];
    }

     //   alert(this.dealId)

    //this.structures = await this.$dao.getDevices(    window.eid,    "*",    "structure",     true   );
    this.structures = await hebelApi.devices.getAll(  "*",    "structure",     true )
    
    if(this.structures.length>0)
      this.project.site.solarRequest.structureId = this.structures[0].id;



    for (var s = 0; s < this.structures.length; s++) {
      this.structureOptions.push({
        value: this.structures[s].id,
        text: `  (${this.structures[s].manufacturer})  ${this.structures[s].structureType}`,
      });
    }





    //this.stringboxes = await this.$dao.getDevices(    window.eid,    "*",    "stringbox",     true   );
    this.stringboxes = await hebelApi.devices.getAll("*",    "stringbox",     true );

    this.stringboxes.sort(function (a, b) {
      return a.nOutputs - b.nOutputs;
    });

    this.stringboxes.sort(function (a, b) {
      return a.nInputs - b.nInputs;
    });
    //Sort
    //this.cables = await this.$dao.getDevices(window.eid, "*", "cable", true);
    this.cables = await hebelApi.devices.getAll( "*", "cable", true)

    //this.connectors = await this.$dao.getDevices(   window.eid,   "*",    "connector",     true   );
    this.connectors = await hebelApi.devices.getAll(  "*",    "connector",     true  );

    //this.transformers = await this.$dao.getDevices(      window.eid,      "*",      "transformer",      true    );
    this.transformers = await hebelApi.devices.getAll(   "*",      "transformer",      true   );

    this.transformers.sort(function (a, b) {
      return a.power - b.power;
    });

    this.loadedCity = true;
    this.loaded = true;
    //alert("created")
  },
  async mounted() {
    if (this.projectId) {
      console.log("Will open project");
      var p = await hebelApi.projects.getFromId(this.projectId);
     // p.quote = this.enterprise;
      console.log(JSON.stringify(p));
      console.log(" opened : " + JSON.stringify(p));
      this.project = p[0];

      if(!this.project.owner){
          this.project.owner = this.user;
          this.project.ownerId = this.user.uid;
      }

      if(this.project.dealId){
          this.deal = await hebelApi.deals.getFromId(this.project.dealId)
      }
      

      if(this.deal.contactId)
          this.project.contact = await hebelApi.contacts.getFromId(this.deal.contactId)

      //alert(JSON.stringify(this.project.contact))
      
      this.$forceUpdate();
    }else{
       // alert("mounted")
      this.deal = this.$session.get("deal");
      //alert(JSON.stringify(this.deal))
      this.project.dealId = this.deal.id;
      this.project.contact.name  = this.deal.contactName;
     // aler
      if(this.deal.contactId){
          this.project.contact = await hebelApi.contacts.getFromId(this.deal.contactId)
       }
      this.project.owner = this.user;
      this.project.ownerId = this.user.uid;
      //alert("mounted3")
    }

    
    //alert("mounted")
    //console.log(JSON.stringify(this.project));
  },
  methods: {
    createCopy(){
      this.$router.push("/project");
       this.project.id = undefined;
       //this.project.dealId = this.$session.get("dealId");

    },
    async saveProject() {
      this.saving = true;
      //var p = await this.$dao.upsertProject(this.project, window.eid);
      var p = await hebelApi.projects.upsert(this.project);

      this.project.id = p.id;
      this.project.code = p.code;
      this.project.createdAt = p.createdAt;
      //this.projectId = this.project.id;
      this.saving = false;

      this.$router.push("/project/" + this.project.id);
    },

    async recalc(){
        this.project.solarPlant.recalcStructure();
        var q = new Quote(this.enterprise, this.fields, this.project.site);
        q.usd_brl = await hebelApi.currencies.usd_brl();


        q.loadProducts(
          this.project.solarPlant
        );
        this.project.quote = q;
        this.calculating = false;
        return;
    },
    async downloadPdf() {
      this.creatingPdf = true;
      //if  this.project.solarPlant.modules[0] is undefined, then load standar perfomance;
      var performanceOverYears = [98,97.55,97.1,96.65,96.2,95.75,95.3,94.85,94.4,93.95,93.5,93.05,92.6,92.15,91.7,91.25,90.8,90.35,89.9,89.45,89,88.55,88.1,87.65,87.2,86.75,86.3,85.85,85.4,84.95 ];

      if (this.project.solarPlant.modules.length > 0)
        performanceOverYears = this.project.solarPlant.modules[0]
          .performanceOverYears;

      this.project.quote.formCashFlow.investmentCost = this.project.quote.price;
      this.project.quote.cashFlow = finance.investmentCashFlow2(
        this.project.quote.formCashFlow.investmentCost,
        this.project.quote.formCashFlow.upFrontInvesment,
        this.project.quote.formCashFlow.numberOfPayments,
        this.project.quote.formCashFlow.loanInterestRate,
        this.project.quote.formCashFlow.inflationRate,
        this.project.solarPlant.production.years,
        this.project.site.electricalProps.averageBilling.price,
        this.project.site.electricalProps.averageBilling.quantity * 12,
        this.project.site.electricalProps.averageBilling.minAmount * 12,
        performanceOverYears
      );
      //teste
      var x;
      x = await pdfDoc.createPdf(
        [],
        [],
        this.project,
        this.enterprise,
        this.formula
      );
      this.creatingPdf = false;
      return;

      // var images = await this.$dao.getImages(window.eid, "quote");
      // images.sort(function (a, b) {
      //   return a.number - b.number;
      // });
      // var pages = [];

      // if (this.project.site.solarRequest.complete)
      //   pages = await this.$dao.getPages(window.eid, "quote");
      // else pages = await this.$dao.getPages(window.eid, "quoteKit");

      // pages.sort(function (a, b) {
      //   return a.number - b.number;
      // });
      // var x;
      // if (this.project.site.solarRequest.complete)
      //   x = pdfDoc.createPdf(pages, images, this.project);
      // else
      // x = pdfDoc.createPdfKit(pages, images, this.project);
      // this.creatingPdf = false;
    },

    async calc() {

      //alert("will calc")
      if (!this.project.site.city) {
        alert("Selecionar cidade")
        return;
      }
      this.project.solarPlant = {};
      var solarFunctions = new SolarFunctions();
      var g;
      var profile = this.enterprise.quoteProfiles[this.project.site.solarRequest.quoteProfileId];
      this.project.profile = profile;
      //console.log(JSON.stringify(profile));

      var structure = this.structures.find(
        (element) => element.id == this.project.site.solarRequest.structureId
      );

     
      if (!this.project.site.solarRequest.customKit) {
        this.generators = await hebelApi.devices.getAll(  "*",          "generator",          true);
        this.generatorsFilter = [];
        for (g = 0; g < this.generators.length; g++) {
          var generator = this.generators[g];
          if (generator.acPhases <= this.project.site.electricalProps.phases) {
            if (
              generator.modules.length > 0 &&
              generator.modules[0].id == this.project.site.solarRequest.moduleId
            ) {
              if (
                generator.structureId ==
                this.project.site.solarRequest.structureId
              ) {
                this.generatorsFilter.push(generator);
              }
            }
          }
        }
        //Not consider modules
        if (this.generatorsFilter.length == 0) {
          for (g = 0; g < this.generators.length; g++) {
            var generator = this.generators[g];
            if (( generator.acPhases <= this.project.site.electricalProps.phases    )||( this.project.site.solarRequest.estimated)) {
              if (
                generator.structureId ==
                this.project.site.solarRequest.structureId
              ) {
                this.generatorsFilter.push(generator);
              }
            }
          }
        }
        this.generatorsFilter.sort(function (a, b) {
          return a.dcPower - b.dcPower;
        });

        this.solarPlants = solarFunctions.getSolarPlantsWithGenerators(
          this.project.site.solarRequest.dcPower,
          this.generatorsFilter,
          this.project.site.electricalProps.voltage,
          this.project.site.electricalProps.phases,
          this.project.site.solarRequest.estimated,
          this.project.site.solarRequest.module
        );
        if (this.solarPlants.length == 0) {
          alert("Nenhuma configuração foi encontrada");
          this.calculating = false;
          return;
        }
        this.project.solarPlant = this.solarPlants[0];
        this.project.solarPlant.city = this.project.site.city;
        this.project.solarPlant.efficiency = this.project.site.solarRequest.efficiency;
        this.project.solarPlant.calcProduction(this.project.site);
        
        if(profile.devicesOptions){
          if(profile.devicesOptions.structure){
              this.project.solarPlant.calcStructure(structure);
                console.log("this.project.solarPlant.mountings")
                console.log(JSON.stringify(this.project.solarPlant.mountings))
          }
        }
        
        var q = new Quote(this.enterprise, this.fields,this.project.site);
        q.usd_brl = await hebelApi.currencies.usd_brl();

        q.loadProducts(
          this.project.solarPlant
        );
        this.project.quote = q;
        this.calculating = false;
        return;
      }
      //alert("will cal2c")

      this.calculating = true;
      this.module = this.modules.find(
        (element) => element.id == this.project.site.solarRequest.moduleId
      );
      var module = new Module();

      if (this.module === null) {
        alert("Módulo não disponível");
        return;
      }
      module = Object.assign(module , this.module);


      this.module = module;
      //this.inverters = await this.$dao.getInverters(        window.eid,        this.project.site.solarRequest.manufacturer,        this.project.site.electricalProps.phases);
      this.inverters =await hebelApi.devices.getInverters( this.project.site.solarRequest.manufacturer,        this.project.site.electricalProps.phases)

      console.log(JSON.stringify(this.inverters));

      //return;

      if (this.inverters.length == 0) {
        alert("Nenhum inversor disponível");
        this.calculating = false;
        return;
      }
      this.inverters.sort(function (a, b) {
        return a.acPower - b.acPower;
      });
      var i;
      this.filterInverters = [];
      for (var a = 0; a < this.inverters.length; a++) {
        i = new Inverter();
        i = Object.assign(i,this.inverters[a])
        i.addDcWiring(this.module);
        if (i.dcMaxPower >= this.project.site.solarRequest.dcPower / 10)
          this.filterInverters.push(i);
      }
      if (this.filterInverters.length == 0) {
        i = new Inverter();
        i = Object.assign(i, this.inverters[this.inverters.length - 1])
        i.addDcWiring(this.module);
        i.quantity = Math.ceil(
          this.project.site.solarRequest.dcPower / i.dcMaxPower
        );
        this.filterInverters.push(i);
      }
      this.filterInverters.sort(function (a, b) {
        return a.acPower - b.acPower;
      });
      console.log(JSON.stringify(this.filterInverters));

      console.log("Filter:");
      for (var x = 0; x < this.filterInverters.length; x++) {
        console.log("inv acPower:" + this.filterInverters[x].acPower);
      }


      this.solarPlants = [];

      this.solarPlants = solarFunctions.getSolarPlants(
        this.project.site.solarRequest.dcPower,
        this.filterInverters,
        this.module,
        this.project.site.electricalProps.voltage,
        this.project.site.electricalProps.phases
      );

      if (this.solarPlants.length == 0) {
        alert("Nenhuma configuração foi encontrada");
        return;
      } else {
        this.project.solarPlant = this.solarPlants[0];
        this.project.solarPlant.city = this.project.site.city;
        this.project.solarPlant.efficiency = this.project.site.solarRequest.efficiency;
        this.project.solarPlant.calcProduction(this.project.site);

     
        this.project.solarPlant.calcStructure(structure);
        //Calc accessories
        this.project.solarPlant.calcAccessories(
          this.project.site.solarRequest.components,
          this.stringboxes,
          this.cables,
          this.connectors,
          this.transformers
        );

      

        var q = new Quote(this.enterprise, this.fields,this.project.site);
        q.usd_brl = await hebelApi.currencies.usd_brl();

        q.loadProducts(
          this.project.solarPlant
        );
        this.project.quote = q;
      }

      this.calculating = false;
    },
  },
};
</script>
<style scoped>
</style>